/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ClasseHoraireIncoherenceSearch
 */
export interface ClasseHoraireIncoherenceSearch {
    /**
     * 
     * @type {number}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    idClasse?: number;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    typeIncoherence?: StringListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    jour?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    local?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    formateur?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    incoherence?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClasseHoraireIncoherenceSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClasseHoraireIncoherenceSearch interface.
 */
export function instanceOfClasseHoraireIncoherenceSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseHoraireIncoherenceSearchFromJSON(json: any): ClasseHoraireIncoherenceSearch {
    return ClasseHoraireIncoherenceSearchFromJSONTyped(json, false);
}

export function ClasseHoraireIncoherenceSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseHoraireIncoherenceSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'typeIncoherence': !exists(json, 'typeIncoherence') ? undefined : StringListSearchFromJSON(json['typeIncoherence']),
        'jour': !exists(json, 'jour') ? undefined : TextSearchFromJSON(json['jour']),
        'local': !exists(json, 'local') ? undefined : TextSearchFromJSON(json['local']),
        'formateur': !exists(json, 'formateur') ? undefined : TextSearchFromJSON(json['formateur']),
        'incoherence': !exists(json, 'incoherence') ? undefined : TextSearchFromJSON(json['incoherence']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClasseHoraireIncoherenceSearchToJSON(value?: ClasseHoraireIncoherenceSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClasse': value.idClasse,
        'typeIncoherence': StringListSearchToJSON(value.typeIncoherence),
        'jour': TextSearchToJSON(value.jour),
        'local': TextSearchToJSON(value.local),
        'formateur': TextSearchToJSON(value.formateur),
        'incoherence': TextSearchToJSON(value.incoherence),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

